// extracted by mini-css-extract-plugin
export default {"attachFile":"styles_attachFile__qN2LH"};